import createModule from "../createModule"
import view from "./view"
import { Creators as CompositeCreators } from "model/compositeSecurity"
import { getQueryFilterAndSort } from "./helpers"
import { getExposedComposites } from "./selectors"
import { getMissingDataFiles } from "selectors/missingDataFiles"

export default createModule({
  view,
  externalProps: state => ({
    account: state.global.selected.account,
    missingDataFiles: getMissingDataFiles(state),
  }),
  required: ["account", "modelId", "date", "factorId"],
  data: [{
    resource: "exposedComposites",
    as: null,
    url: ({ modelId, date, factorId, missingDataFiles }) => {
      const { filter: filterPositive, sort: sortPositive } = getQueryFilterAndSort(factorId, "positive", missingDataFiles)
      const { filter: filterNegative, sort: sortNegative } = getQueryFilterAndSort(factorId, "negative", missingDataFiles)

      return {
        id: `${modelId}${date}${factorId}`,
        query: `query ($modelId: String!, $date: Date!, $factorId: String!, $filterPositive: [SecuritySearchFilter!]!, $sortPositive: [SecuritySearchSort!]!, $filterNegative: [SecuritySearchFilter!]!, $sortNegative: [SecuritySearchSort!]!) {
  model (id: $modelId) {
    positive: securitySearch (on: $date, filter: $filterPositive, sort: $sortPositive, take: 12) {
      securities {
        id
        internalId
        ticker
        mic
        country
        description
        assetClass
        factorExposure (id: [$factorId]) {
          zScore
        }
      }
    },
    negative: securitySearch (on: $date, filter: $filterNegative, sort: $sortNegative, take: 12) {
      securities {
        id
        internalId
        ticker
        mic
        country
        description
        assetClass
        factorExposure (id: [$factorId]) {
          zScore
        }
      }
    }
  }
}`,
        variables: {
          modelId,
          date,
          factorId,
          filterPositive,
          sortPositive,
          filterNegative,
          sortNegative,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    exposedComposites: getExposedComposites(state, props),
  }),
  actions: {
    openCompositeSecurity: CompositeCreators.openCompositeSecurity,
  },
})
